import { Controller } from "stimulus";

type Feature = {
  key: string;
  tooltip?: string;
  position?: string; // "top", "right", "bottom", "left"
};

export default class extends Controller {
  static values = {
    features: Array,
  };

  declare featuresValue: Feature[];
  tooltipEl?: HTMLDivElement;

  connect() {
    this.featuresValue.forEach((feature: Feature) => {
      const elements = document.querySelectorAll<HTMLElement>(feature.key);
      if (elements.length === 0) return;

      elements.forEach((el) => {
        // Add badge
        if (!el.querySelector(".badge-new")) {
          const badge = document.createElement("span");
          badge.className = "badge-new";
          badge.innerText = "NEW";
          badge.style.marginLeft = "6px";
          el.appendChild(badge);
        }

        // Add tooltip behavior
        if (feature.tooltip) {
          el.addEventListener("mouseenter", () =>
            this.showTooltip(el, feature.tooltip!, feature.position || "right")
          );
          el.addEventListener("mouseleave", () => this.hideTooltip());
        }
      });
    });
  }

  showTooltip(target: HTMLElement, content: string, preferredPosition: string) {
    this.hideTooltip();

    this.tooltipEl = document.createElement("div");
    this.tooltipEl.className = "tooltip-feature";
    this.tooltipEl.textContent = content;
    document.body.appendChild(this.tooltipEl);

    const rect = target.getBoundingClientRect();
    const tooltipRect = this.tooltipEl.getBoundingClientRect();
    const spacing = 8;
    const scrollX = window.scrollX;
    const scrollY = window.scrollY;

    let top = 0,
      left = 0;
    let finalPosition = preferredPosition;

    switch (preferredPosition) {
      case "top":
        top = scrollY + rect.top - tooltipRect.height - spacing;
        left = scrollX + rect.left + (rect.width - tooltipRect.width) / 2;
        if (top < 0) finalPosition = "bottom";
        break;
      case "bottom":
        top = scrollY + rect.bottom + spacing;
        left = scrollX + rect.left + (rect.width - tooltipRect.width) / 2;
        if (top + tooltipRect.height > window.innerHeight)
          finalPosition = "top";
        break;
      case "left":
        top = scrollY + rect.top + (rect.height - tooltipRect.height) / 2;
        left = scrollX + rect.left - tooltipRect.width - spacing;
        if (left < 0) finalPosition = "right";
        break;
      default:
        top = scrollY + rect.top + (rect.height - tooltipRect.height) / 2;
        left = scrollX + rect.right + spacing;
        if (left + tooltipRect.width > window.innerWidth)
          finalPosition = "left";
        break;
    }

    if (finalPosition !== preferredPosition) {
      switch (finalPosition) {
        case "top":
          top = scrollY + rect.top - tooltipRect.height - spacing;
          left = scrollX + rect.left + (rect.width - tooltipRect.width) / 2;
          break;
        case "bottom":
          top = scrollY + rect.bottom + spacing;
          left = scrollX + rect.left + (rect.width - tooltipRect.width) / 2;
          break;
        case "left":
          top = scrollY + rect.top + (rect.height - tooltipRect.height) / 2;
          left = scrollX + rect.left - tooltipRect.width - spacing;
          break;
        case "right":
          top = scrollY + rect.top + (rect.height - tooltipRect.height) / 2;
          left = scrollX + rect.right + spacing;
          break;
      }
    }

    this.tooltipEl.classList.add(finalPosition);
    this.tooltipEl.style.top = `${top}px`;
    this.tooltipEl.style.left = `${left}px`;
    requestAnimationFrame(() => this.tooltipEl?.classList.add("visible"));
  }

  hideTooltip() {
    this.tooltipEl?.remove();
    this.tooltipEl = undefined;
  }
}
